import { render, staticRenderFns } from "./MainPageSections.vue?vue&type=template&id=e2c5e456&scoped=true&"
import script from "./MainPageSections.vue?vue&type=script&lang=js&"
export * from "./MainPageSections.vue?vue&type=script&lang=js&"
import style0 from "./MainPageSections.vue?vue&type=style&index=0&id=e2c5e456&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c5e456",
  null
  
)

export default component.exports